module.exports = __webpack_public_path__ + "static/media/exclamation-circle.80739489.svg";